import { useState } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { ISearchPage, OptionDsType } from "@/types/FmsTypes";
import {
    DEFAULT_FIRST_PAGE_NUM,
    DEFAULT_PAGE_SIZE,
    defaultMdCmParam
} from "@/utils/constants";
import {
    accountService
} from "../../../AccountService";
import { transPgToPagination } from "../../../../base/app/appModel";
import { IAccountSummary, ICustomerAccountSummary } from "../../../AccountTypes";
import { IMdCustomerFields } from "../../../../base/customer/customerService";
import { ITreeData } from "../../../../base/dict/dictModel";
import { IMdOrgDetail, orgService } from "../../../../base/org/orgService";
import { message } from "antd";

export const useSummaryModel = createModel(function () {
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

    //查询条件
    const [searchParam, setSearchParam] = useState<IMdCustomerFields>({});
    //列表数据源
    const [dataSource, setDataSource] = useState<ICustomerAccountSummary[]>([]);

    const [summaryData, setSummaryData] = useState<IAccountSummary>({});
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<ICustomerAccountSummary[]>([]);
    const [selectedData, setSelectedData] = useState<ICustomerAccountSummary>();
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    const [orgDs, setOrgDs] = useState<ITreeData<IMdOrgDetail>[]>();
    const [supplierTypeDs, setSupplierType] = useState<OptionDsType[]>();
    const [appDs, setAppDs] = useState<OptionDsType[]>();

    //账户初始化
    const [initAccountVisible, setInitAccountVisible] = useState<boolean>(false);

    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = (updateParam: IMdCustomerFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSelectedRowKeys([]);
        setSearchParam({});
        loadData(initPgCfg, {});
    }
    const clearSelectData = () => {
        setSelectedRowKeys([]);
        setSelectedData(undefined)
    }

    const loadData = async (page: ISearchPage = initPgCfg, searchValue: IMdCustomerFields = searchParam) => {
        const searchParams = {
            ...defaultMdCmParam,
            ...searchValue,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData } = await accountService.supplierSummaryPage(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);

        let { retData: summaryData } = await accountService.supplierSummary(searchParams);
        setSummaryData(summaryData);
        clearSelectData();
    }
    const loadDataAll = async () => {
        const searchParams = {
            ...defaultMdCmParam,
            ...searchParam,
            page: {
                pageSize: 1000000,
                pageNum: 1
            }
        }
        let { retData } = await accountService.supplierSummaryPage(searchParams);
        const { records, ...pg } = retData;
        if (records && records.length > 0) {
            setSelectedRowKeys(records);
            setInitAccountVisible(true);
        } else {
            message.warning("没有符合条件的数据")
        }

    }

    const getSelectedData = () => {
        return selectedData;
    }
    return {
        /***field***/
        setOrgDs, appDs, setAppDs,
        setSupplierType,
        setSelectedData,
        initPgCfg,
        orgDs,
        supplierTypeDs,
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        selectedData,
        summaryData,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData, loadDataAll,
        updatePgCfg,
        getSelectedData,
        initAccountVisible, setInitAccountVisible
    }
});
